"use client";

import styles from "./styles/voice-top-info.module.scss";
import favouriteIcon from "@/assets/icons/favorite.svg";
import favouriteHoverIcon from "@/assets/voices/card/favorite-hover.svg";
import favouriteActiveIcon from "@/assets/voices/card/favorite-active.svg";

import IconStateButton from "@/components/pages/home/components/voices/icon-state-button";
import { useCallback, useState } from "react";
import { useSession } from "next-auth/react";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useVoiceCardHeader } from "@/components/pages/home/hooks/use-voice-card-header";

type VoiceTopInfo = {
  modelId: string;
  isHot: boolean;
  isFavouriteModel?: boolean;
  usesCount?: number;
  handleClick: () => void;
};

const VoiceTopInfo = ({
  modelId,
  isHot,
  isFavouriteModel,
  usesCount,
  handleClick,
}: VoiceTopInfo) => {
  const { toggleFavourite } = useVoiceCardHeader();
  const { showModal } = useGlobalModalContext();
  const showErrorModal = (title?: string, message?: string) =>
    showModal({
      type: "error_modal",
      props: {
        title: title,
        message: message,
      },
    });
  const session = useSession();
  const userId = session.data?.user?.id;
  const [isFavourite, setIsFavourite] = useState(isFavouriteModel ?? false);
  const handleFavouriteClick = useCallback(async () => {
    if (!userId) {
      showErrorModal(
        "You are unauthorized",
        "You must be logged in to perform this action",
      );
      return;
    }
    await toggleFavourite(modelId, userId);
    setIsFavourite(!isFavourite);
  }, [userId, modelId, toggleFavourite]);

  return (
    <div className={styles.info} onClick={handleClick}>
      {/*{isHot && <Image className={styles.icon} src={hotIcon} alt="Hot" />}*/}
      <div className={styles.uses_info}>
        {usesCount && (
          <div className={styles.uses_count}>
            {(usesCount / 1000).toFixed(1)}K
          </div>
        )}

        <div className={styles.favourite_button}>
          <IconStateButton
            baseIcon={favouriteIcon}
            hoverIcon={favouriteHoverIcon}
            activeIcon={favouriteActiveIcon}
            isActive={isFavourite}
            size={24}
            onClick={handleFavouriteClick}
          />
        </div>
      </div>
    </div>
  );
};

export default VoiceTopInfo;
